import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=49fcf319&scoped=true&"
import script from "./ProfileImage.vue?vue&type=script&lang=js&"
export * from "./ProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./ProfileImage.vue?vue&type=style&index=0&id=49fcf319&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fcf319",
  null
  
)

export default component.exports